















































































































































import CompanySheet from "@/components/company/CompanySheet.vue";
import MExpansion from "@/components/utility/mmmint/MExpansion.vue";
import MIconButton from "@/components/utility/mmmint/MIconButton.vue";
import MNoContent from "@/components/utility/mmmint/MNoContent.vue";
import MTextField from "@/components/utility/mmmint/MTextField.vue";
import { ContractTypeEnum } from "@/lib/enum/contract-type.enum";
import { handleError } from "@/lib/utility/handleError";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { CompanyWithGeoAndDistanceBase } from "@/models/company.entity";
import { IWorkshopContractRate } from "@/models/workshop-contract-rate.entity";
import { PartnerModule } from "@/store/modules/partner";
import CompanyMapDialog from "@/views/company/CompanyMapDialog.vue";
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";

@Component({
  components: {
    MIconButton,
    MNoContent,
    CompanyMapDialog,
    CompanySheet,
    MExpansion,
    MTextField
  },
  filters: {}
})
export default class PartnerReportSelectWorkshopCard extends mixins(PermissionMixin) {
  get partner() {
    return PartnerModule.partner;
  }

  get report() {
    return PartnerModule.report;
  }

  get workshopContract() {
    return this.report.workShopCompany?.findActiveContract(ContractTypeEnum.WORKSHOP);
  }

  get workshopContractDetails(): IWorkshopContractRate | undefined {
    return this.workshopContract?.details as IWorkshopContractRate;
  }

  get vehicleLocationString(): string {
    const location = this.report.location || {};
    const parts = [];

    if (location.street) {
      parts.push(location.street);
    }

    const zipCity = [location.zip, location.city].filter(Boolean).join(" ");
    if (zipCity) {
      parts.push(zipCity);
    }

    return parts.join(", ");
  }

  goToWorkshopDetails() {
    this.report.workShopCompany?.goTo(this.$router).detail();
  }

  isUpdatingReport = false;
  selectWorkshopDialog = false;
  search = "";
  showDetails = false;

  get reportWorkshopId() {
    return this.report.workshopCompanyId;
  }

  get selectWorkShopIcon() {
    if (this.reportWorkshopId) {
      return "mdi-pencil-outline";
    }
    return "mdi-plus";
  }

  openDialog() {
    this.search = this.vehicleLocationString;
    this.selectWorkshopDialog = true;
  }

  async selectWorkshop(company: CompanyWithGeoAndDistanceBase) {
    if (!company) {
      return;
    }
    this.isUpdatingReport = true;

    (await this.report.updatePartial({ workshopCompanyId: company.id }).catch(error => handleError(error))) || null;
    await this.fetchWorkshop();

    this.isUpdatingReport = false;

    this.selectWorkshopDialog = false;
  }

  private async fetchWorkshop() {
    await this.report.fetchWorkshopEntity().catch(handleError);
    this.report.workShopCompany?.fetchContracts().catch(handleError);
  }
}
